import { createAction, createSlice } from "@reduxjs/toolkit";
import { ANALYTICS_REMOVE_PENDING_EVENT } from "./constants";
import { analyticsAddPendingRefinementsToggled } from "./actions/analyticsPending";

const clearPendingAnalytics = createAction(ANALYTICS_REMOVE_PENDING_EVENT);

const analyticsSlice = createSlice({
  name: "analytics",
  initialState: { pendingAnalytics: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(analyticsAddPendingRefinementsToggled, (state, action) => {
        state.pendingAnalytics = {
          ...action.payload,
        };
      })
      .addCase(clearPendingAnalytics, (state) => {
        state.pendingAnalytics = {};
      });
  },
});

export default analyticsSlice.reducer;
